import styled from 'styled-components';
import { Container } from './SelectedItemsEmptyState.styles';

export const LoadingState = styled(Container)`
  cursor: default;

  &:hover {
    background-color: #f8f9fa;
    border-color: #dee2e6;
  }
`;

const CARD_SIZE = '210px';

export const ItemContainer = styled.div`
  width: ${CARD_SIZE};
  flex-shrink: 0;
`;

export const FooterButton = styled.button.attrs({
  type: 'button',
})`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  color: #be1622;
  border: 1px dashed #dee2e6;
  flex-shrink: 0;
  padding: 0;

  i {
    font-size: 36px;
    line-height: 1;
  }

  &:hover {
    background-color: #e9ecef;
    border-color: #ccc;
  }

  &:active {
    background-color: #dde1e5;
    transform: scale(0.98);
  }
`;
